import { FormattedMessage, useIntl } from 'react-intl';
import React from 'react';

export const ProductionHelpText = () => {
  const intl = useIntl();

  return (
    <div className='bg-white row'>
      <h3 className='col-12 title-journey fw-bold my-24'>
        <FormattedMessage
          id='ec.confirmation.gestaltungProduktion'
          defaultMessage='Gestaltungs- und Produktions-Service'
        />
      </h3>

      <p className='col-12 mb-24 sub-title'>
        <FormattedMessage
          id='ec.confirmation.gestaltungProduktionText'
          defaultMessage='Wir unterstützen Sie gerne bei Ihrer gebuchten Kampagne mit unseren Services zur Gestaltung Ihres Werbesujets/Spots, der Abwicklung Ihres Druckauftrags oder bei der Anlieferung Ihres Spots.'
        />
      </p>

      <div className='d-flex col-8 my-4'>
        <div className='col-12 ps-0'>
          <p className='fw-bold mb-3 title-journey'>
            <FormattedMessage id='ec.confirmation.questionOne' defaultMessage='Und wie geht das?' />
          </p>

          <p className='mb-48 sub-title'>
            <FormattedMessage
              id='ec.confirmation.questionOneText'
              defaultMessage='Ganz einfach, wählen Sie unten zu Ihrer gebuchten Kampagne den gewünschten Service aus. Alles Weitere wird Ihnen dann Schritt für Schritt erklärt.'
            />
          </p>
        </div>

        <div className='col-8'>
          <p className='fw-bold mb-3 title-journey'>
            <FormattedMessage
              id='ec.confirmation.questionTwo'
              defaultMessage='Möchten Sie sich später darum kümmern?'
            />
          </p>

          <p className='mb-48 sub-title'>
            <FormattedMessage
              id='ec.confirmation.questionTwoText'
              defaultMessage='Kein Problem, Sie können jederzeit nach dem Login auf unserer Website über das Dashboard auf Ihre gebuchten Kampagnen und deren Services zugreifen.'
            />
          </p>
        </div>

        <div className='col-8 pe-0'>
          <p className='fw-bold mb-3 title-journey'>
            <FormattedMessage id='ec.confirmation.questionThree' defaultMessage='Haben Sie Fragen?' />
          </p>

          <p className='mb-48 sub-title'>
            <FormattedMessage
              id='ec.confirmation.questionThreeText'
              defaultMessage='Unser ServiceDesk hilft Ihnen gerne weiter. Via Telefon oder <a>E-Mail</a>.'
              values={{
                a: (child) => (
                  <a
                    className='red-text'
                    href={`mailto:${intl.formatMessage({
                      id: 'ec.confirmation.questionThreeTextLink',
                      defaultMessage: 'servicedesk@apgsga.ch',
                    })}`}
                  >
                    {child}
                  </a>
                ),
              }}
            />
          </p>
        </div>
      </div>
    </div>
  );
};
